<div class="wrapper">
  <div mat-dialog-title>{{title}}</div>
  <div mat-dialog-content>
    <p>{{message}}</p>
  </div>
  <div mat-dialog-actions [ngClass]="(btnCancelText && btnOkText) ?  'd-flex justify-content-between' : 'justify-content-center'">
    <div *ngIf="btnCancelText">
      <button mat-button mat-stroked-button (click)="pressButtonCancel()">{{btnCancelText}}</button>
    </div>
    <div *ngIf="btnOkText">
      <button mat-button mat-flat-button color="accent" class="text-white" (click)="pressButtonOk()">{{btnOkText}}</button>
    </div>
  </div>

</div>
